export interface VoiceAIConfig {
  apiKey: string;
  baseUrl?: string;
  timeout?: number; // milliseconds, default 30000 (30s)
}

export class VoiceAI {
  private static instance: VoiceAI;
  private config: VoiceAIConfig;

  constructor(config: VoiceAIConfig) {
    this.config = {
      baseUrl: 'https://api.slng.ai',
      ...config,
    };
    VoiceAI.instance = this;
  }

  static getInstance(): VoiceAI {
    if (!VoiceAI.instance) {
      throw new Error(
        'VoiceAI not initialized. Please call new VoiceAI({ apiKey: "your-key" }) first.\n' +
        'Get your API key at https://slng.ai/signup'
      );
    }
    return VoiceAI.instance;
  }

  getConfig(): VoiceAIConfig {
    return this.config;
  }

  updateApiKey(apiKey: string): void {
    this.config.apiKey = apiKey;
  }
}